<template>
    <el-card class="archive-card">
        <div slot="header" class="card-header">
            <router-link to="/archives" class="header-title-link">{{cardHeader}}</router-link>
        </div>

        <div class="archive-list">
            <div v-if="archives.length === 0" class="archive-empty">还没有任何归档，写几篇文章试试吧</div>
            <router-link v-else v-for="a in archives" :key="a.year + a.month"
                        :to="{ path: '/archives' }"
                        class="archive-item">
                <div class="archive-dot"></div>
                <div class="archive-info">
                    <span class="archive-date">{{a.year}}年{{a.month}}月</span>
                    <span class="archive-count">{{a.count}}篇</span>
                </div>
            </router-link>
        </div>
    </el-card>
</template>

<script>
    export default {
        name: "ArchiveCard",
        props: {
            cardHeader: {
                type: String,
                required: true
            },
            archives: {
                type: Array,
                required: true
            }
        },
        methods: {}
    }
</script>

<style scoped>
    /* 归档卡片 */
    .archive-card :deep(.el-card__header) {
        padding: 20px 24px 12px;
        border-bottom: none;
    }

    .archive-card :deep(.el-card__body) {
        padding: 0 24px 20px !important;
    }

    .card-header {
        display: flex;
        align-items: center;
    }

    .header-title-link {
        font-size: 15px;
        font-weight: 600;
        color: var(--text-primary);
        letter-spacing: 0.3px;
        text-decoration: none;
        transition: color 0.2s ease;
    }
    .header-title-link:hover {
        color: var(--accent-warm);
    }

    /* 归档列表 */
    .archive-list {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .archive-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 10px 0;
        cursor: pointer;
        transition: all 0.2s ease;
        border-bottom: 1px solid var(--bg-secondary);
        text-decoration: none;
        color: inherit;
    }

    .archive-item:last-child {
        border-bottom: none;
    }

    .archive-item:hover .archive-date {
        color: var(--accent-warm);
    }

    .archive-item:hover .archive-dot {
        background: var(--accent-warm);
        transform: scale(1.2);
    }

    /* 圆点 */
    .archive-dot {
        width: 6px;
        height: 6px;
        background: var(--text-tertiary);
        border-radius: 50%;
        transition: all 0.2s ease;
        flex-shrink: 0;
    }

    /* 信息 */
    .archive-info {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;
    }

    .archive-date {
        font-size: 13px;
        color: var(--text-secondary);
        transition: color 0.2s ease;
    }

    .archive-count {
        font-size: 11px;
        color: var(--text-tertiary);
        background: var(--bg-secondary);
        padding: 2px 8px;
        border-radius: 10px;
    }

    .archive-empty {
        font-size: 13px;
        color: var(--text-tertiary);
        padding: 12px 0;
        text-align: center;
    }
</style>
